/** Início da conta Otto: as chamadas de vídeo (docs/specs/otto/TDD.md §5). */
export const OTTO_HOME_PATH = '/internal/otto';

/**
 * Para onde a pessoa vai ao cair em `/internal/dashboard`: a entrada depois do login e o destino de todo "voltar ao
 * início" (404, guarda de rota, link quebrado). Um só lugar decide, então a conta Otto nunca cai na casca da plataforma.
 *
 * @param {{ isSuperAdmin: boolean, accountId?: string | null, isOtto: boolean }} who
 * @returns {string | null} o caminho, ou `null` quando a pessoa fica no dashboard global (superadmin)
 */
export function homeDestination({ isSuperAdmin, accountId, isOtto }) {
    if (isSuperAdmin) return null;
    if (isOtto) return OTTO_HOME_PATH;
    if (accountId) return `/internal/implementation/${accountId}`;
    return null;
}
